import { ReducerBuilder } from './reducerBuilder';
import { LoyaltyTransactionsState } from 'acscp/store/loyaltyTransactionsState';
import { LoyaltyTransactionsList } from 'acscp/api/models/loyaltyTransactionsList';
import { TransactionHistoryRequest } from 'acscp/api/requests/transactionHistoryRequest';

export const loyaltyTransactionsReducer =
    new ReducerBuilder<LoyaltyTransactionsState>({transactions: []})
        .successfulRequestCase(TransactionHistoryRequest, (state, response: LoyaltyTransactionsList) => {
            const storeTransactions: LoyaltyTransactionsState = {
                transactions: response.transactions.map(transaction => ({
                    date: transaction.date,
                    activity: transaction.activity,
                    pointsChange: transaction.pointsChange,
                    total: transaction.total
                }))
            };
            return storeTransactions;
        })
        .build();
